import { SESSION_STATE_LABEL } from "@/content/status"
import type { SessionState } from "@/utils/sessionLifecycle"
import styles from "@/styles/components/StatusDot.module.css"

/**
 * A session's state, as a coloured dot and a word.
 *
 * Both, always. The dot alone would be the only carrier of the fact, and the
 * four hues are close enough in value that a colour-blind reader would be
 * guessing — so the label is not optional and there is no icon-only variant.
 */

interface StatusDotProps {
  state: SessionState
  /** Smaller, for a table row rather than a card header. */
  compact?: boolean
}

export default function StatusDot({ state, compact = false }: StatusDotProps) {
  return (
    <span className={compact ? `${styles.wrap} ${styles.compact}` : styles.wrap}>
      <span className={`${styles.dot} ${styles[state]}`} aria-hidden="true" />
      {SESSION_STATE_LABEL[state]}
    </span>
  )
}
